<template>
  <div class="wrapper-template"
       id='sectionContainer'>
    
    <div class="inner-wrapper-one">
      <ul class="aside-social-list aside-social-list_mobile">
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_f" v-if="langMain.socialList.facebook.isVisible" :href="langMain.socialList.facebook.link"  target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_vk" v-if="langMain.socialList.vk.isVisible" :href="langMain.socialList.vk.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_inst" v-if="langMain.socialList.inst.isVisible" :href="langMain.socialList.inst.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_git" v-if="langMain.socialList.git.isVisible" :href="langMain.socialList.git.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_be" v-if="langMain.socialList.be.isVisible" :href="langMain.socialList.be.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_dr" v-if="langMain.socialList.dribbble.isVisible" :href="langMain.socialList.dribbble.link" target="_blank"></a>
        </li>
      </ul>
      
      <div class="wrapper-template__inner wrapper-template__inner_mobile">
       
        <div class="menu-col menu-col_anim-delay-1" id='about'>
          <div class="menu-col__title"
               @click="toggleClass('about')">{{lang.about.title}}</div>
          <ul class="mode-side-list-info-detail__list padd">
            <li @click="next('', 'slide', 'about')" class="mode-side-list-info-detail__item">
              <div class="num">01</div> <span>{{lang.about.items[0].label}}</span>
            </li>
            <li class="mode-side-list-info-detail__item mode-side-list-info-detail__item_sm">
              <div class="num">02</div>
              <span @click="next('two', 'slide', 'about')">{{lang.about.items[1].label}}</span>
              <ul class="menu-inner-list">
                <li @click="next('branding', 'slide', 'about')" class="menu-inner-list__item"><div>{{lang.about.items[1].innerList[0].label}}</div></li>
                <li @click="next('sales-activation', 'slide', 'about')" class="menu-inner-list__item"><div>{{lang.about.items[1].innerList[1].label}}</div></li>
                <li @click="next('business-expansion', 'slide', 'about')" class="menu-inner-list__item"><div>{{lang.about.items[1].innerList[2].label}}</div></li>
              </ul>
            </li>
            <li @click="next('three', 'slide', 'about')" class="mode-side-list-info-detail__item">
              <div class="num">03</div> <span>{{lang.about.items[2].label}}</span>
            </li>
          </ul>
        </div>

        <div class="menu-col menu-col_anim-delay-2" id='vision'>
          <div class="menu-col__title"
               @click="toggleClass('vision')">{{lang.vision.title}}</div>
          <ul start='00' class="mode-side-list-info-detail__list padd">
            <li @click="next('', 'slide', 'vision')" class="mode-side-list-info-detail__item"> <div class="num">00</div> <span>{{lang.vision.items[0].label}}</span></li>
            <li @click="next('one', 'slide', 'vision')" class="mode-side-list-info-detail__item"><div class="num">01</div> <span>{{lang.vision.items[1].label}}</span></li>
            <li @click="next('two', 'slide', 'vision')" class="mode-side-list-info-detail__item"><div class="num">02</div> <span>{{lang.vision.items[2].label}}</span></li>
            <li @click="next('three', 'slide', 'vision')" class="mode-side-list-info-detail__item"><div class="num">03</div> <span>{{lang.vision.items[3].label}}</span></li>
            <li @click="next('four', 'slide', 'vision')" class="mode-side-list-info-detail__item"><div class="num">04</div> <span>{{lang.vision.items[4].label}}</span></li>
            <li @click="next('five', 'slide', 'vision')" class="mode-side-list-info-detail__item"><div class="num">05</div> <span>{{lang.vision.items[5].label}}</span></li>
            <li @click="next('six', 'slide', 'vision')" class="mode-side-list-info-detail__item"><div class="num">06</div> <span>{{lang.vision.items[6].label}}</span></li>
          </ul>
        </div>

        <div class="menu-col menu-col_anim-delay-3" id='career'>
          <div class="menu-col__title"
               @click="toggleClass('career')">{{lang.career.title}}</div>
          <ul class="mode-side-list-info-detail__list">
            <li @click="next('', 'slide', 'career')" class="mode-side-list-info-detail__item"><span>{{lang.career.items[0].label}}</span></li>
            <!-- <li @click="next('chat', 'slide-to-up', 'career')" class="mode-side-list-info-detail__item"><span>{{lang.career.items[1].label}}</span></li> -->
          </ul>
        </div>

        <div class="menu-col menu-col_marg-zero menu-col_anim-delay-4" id='contacts'>
          <div class="menu-col__title"
               @click="toggleClass('contacts')">{{lang.contacts.title}}</div>
          <ul class="mode-side-list-info-detail__list">
            <li @click="next('', 'slide', 'contacts')" class="mode-side-list-info-detail__item"><span>{{lang.contacts.items[0].label}}</span></li>
            <!-- <li @click="next('contacts-chat', 'slide', 'contacts')" class="mode-side-list-info-detail__item"><span>{{lang.contacts.items[1].label}}</span></li> -->
          </ul>
        </div>

        <div class="menu-col menu-col_terms menu-col_anim-delay-5">
          <ul class="">
            <li class="mode-side-list-info-detail__item">
              <span @click="openTermsEtc('cookie-policy')" class="footer-list__link">{{langMain.footerInfo.cookiesPolicy}}</span>
            </li>
            <li class="mode-side-list-info-detail__item">
              <span @click="openTermsEtc('terms-of-use')" class="footer-list__link">{{langMain.footerInfo.terms}}</span>
            </li>
            <li class="mode-side-list-info-detail__item">
              <span @click="openTermsEtc('privacy-policy')" class="footer-list__link">{{langMain.footerInfo.privacyPolicy}}</span>
            </li>
          </ul>
          <languageSelect page="index.html#" v-bind:url-route="''" list-class="lang-list-menu" />
        </div>

      </div>
    </div>

    <!-- <div class="btn-next-wrapper" @click="next('chat', 'slide-to-up', 'index')">
      <div id="menu_start_chat" class="button-slider button-slider_position-bottom-right">
        <img class="to-right-icon" src="../../public/assets/images/arrow_icon_white.png" alt="">
      </div>
    </div> -->

    <!-- <div class="text-next-wrapper">
      <div class="next-btn-info-text next-btn-info-text_position-bottom-right">{{lang.startChat}}</div>
    </div> -->
  </div>
</template>

<script>
import switchClasses from '@/util/switcherClasses.js'
import languageSelect from '@/views/language-select/language-select'

import {baseUrl} from '@/../vue.config'

export default {
  name: 'Menu',

  data() {
    return {
      lastClickedCol: '',
      lang: this.$root.$options.LANG.MENU,
      langMain: this.$root.$options.LANG,
    }
  },

  methods: {
    next: function(toRoute, slideName, toPage) {
      let pathname = window.location.pathname;

      if(pathname.search(toPage) !== -1) {
        this.gotoRoute(toRoute, slideName);
      } else {
        this.goToPage(toRoute, toPage);
      }

    },
    
    gotoRoute: function(toRoute, slideName, toPage) {
      switchClasses({add: 'hide',remove: 'show'}, 'sectionContainer');

      this.$emit('animationName', [slideName, {close: true, transition: {to: toRoute}}]);
      
      setTimeout(() => {
        if (toPage) return this.$router.push(`/${toPage}#/${toRoute}`);
        
        this.$router.push(`/${toRoute}`)
      }, 500);
    },

    goToPage: function(toRoute, toPage) {
      this.$emit('loader', [true]);
      setTimeout(() => {
        location.assign(`${baseUrl}${toPage}.html#/${toRoute}`);          
      }, 700);
    },

    toggleClass: function(nameCol) {
      if(this.lastClickedCol === nameCol) {
        let el = document.getElementById(nameCol);
        el.classList.remove('open');
        this.lastClickedCol = '';
        return;
      }
      let cols = document.querySelectorAll('.menu-col');
      Array.prototype.forEach.call(cols, item => {item.classList.remove('open')});

      let el = document.getElementById(nameCol);
      el.classList.add('open');

      this.lastClickedCol = nameCol;
    },

    openTermsEtc: function(nameRoute) {
      this.$emit('termsOpen', [nameRoute]);
    }

  },

  mounted: function() {
    switchClasses({add: 'show',remove: 'hide'}, 'sectionContainer');
    this.$emit('isNotFound', [{is: true}]);
  },

  components: {
    languageSelect
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.inner-wrapper-one {
  min-height: 100%;
}
.menu-col .mode-side-list-info-detail__item {
  display: list-item;
}
.wrapper-template__inner {
  padding-bottom: 0 !important;
  min-height: auto !important;
}

.menu-inner-list__item {
  font-size: 12px;
}

.num {
  display: inline-block;
  font-size: 12px !important;
  margin: 0;
  position: static;
}
</style>
